import { calculateInstallment } from '@/js/api/forms.ts';
import { clearField, FIELD_SELECTOR, showFieldError } from '@/js/fields.ts';
import { reachGoal } from '@/js/goal.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify } from '@/js/notification.ts';
import { Captcha, RECAPTCHA_FIELD_NAME } from '@/js/recaptcha.ts';

const ERROR_MESSAGE = 'Поле пустое';
const FIRST_STEP_FIELD_NAMES = ['installment_type', 'square'];
const SECOND_STEP_FIELD_NAMES = ['name', 'email', 'phone'];
const FIRST_STEP = 'first';
const SECOND_STEP = 'second';
const SUCCESS_CLASS = 'success';

function addFormListener(form: HTMLFormElement): void {
  const captcha = new Captcha(form);

  const fieldElements = form.querySelectorAll<HTMLElement>(FIELD_SELECTOR);
  const clearFieldErrors = (): void => {
    for (const element of fieldElements) {
      clearField(element);
    }
  };
  const setFieldError = (name: string, message: string): void => {
    const inputElement = form.querySelector<HTMLElement>(`[name="${name}"]`);
    showFieldError(inputElement, message);
  };

  const validateFields = (formData: FormData, requiredFieldNames: string[]): boolean => {
    let isValid = true;

    for (const fieldName of requiredFieldNames) {
      const value = formData.get(fieldName)?.toString().trim();
      if (!(value ?? '')) {
        setFieldError(fieldName, ERROR_MESSAGE);
        isValid = false;
      }
    }

    return isValid;
  };

  // eslint-disable-next-line ts/no-misused-promises
  form.addEventListener('submit', async (event: SubmitEvent) => {
    event.preventDefault();
    clearFieldErrors();
    try {
      const currentStep = form.getAttribute('data-step');
      const goalName = form.getAttribute('data-goal-name') ?? '';
      const formData = new FormData(form);

      if (currentStep === FIRST_STEP && validateFields(formData, FIRST_STEP_FIELD_NAMES)) {
        form.setAttribute('data-step', SECOND_STEP);
      }
      else if (currentStep === SECOND_STEP && validateFields(formData, SECOND_STEP_FIELD_NAMES)) {
        captcha.render();
        const token = await captcha.execute();
        formData.set(RECAPTCHA_FIELD_NAME, token);
        const response = await calculateInstallment(formData);
        if (response.data?.success) {
          form.reset();
          form.setAttribute('data-step', FIRST_STEP);
          form.classList.add(SUCCESS_CLASS);
          captcha.reset();

          if (goalName) {
            reachGoal(goalName);
          }
        }
        else {
          showErrorNotify({ text: ERROR_REQUEST_TEXT });
        }
      }
    }
    catch (error) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      console.error((error as Error).message);
    }
  });
}

const forms = document.querySelectorAll<HTMLFormElement>('.js-installation-banner-form');
for (const form of forms) {
  addFormListener(form);
}
